import { FC, HTMLProps } from 'react';

export const DashboardEmptyIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="152"
      height="133"
      viewBox="0 0 152 133"
      fill="none"
      {...props}
    >
      <rect x="30.5" y="41.688" width="11" height="68.4873" rx="4" fill="#D5DBDE" />
      <rect x="0.5" y="24.8142" width="11" height="85.361" rx="4" fill="#D5DBDE" />
      <rect x="15.5" width="11" height="110.175" rx="4" fill="#D5DBDE" />
      <rect x="45.5" y="41.688" width="11" height="68.4873" rx="4" fill="#D5DBDE" />
      <rect x="60.5" y="6.948" width="11" height="103.227" rx="4" fill="#D5DBDE" />
      <rect x="75.5" y="6.948" width="11" height="103.227" rx="4" fill="#D5DBDE" />
      <rect x="75.5" y="60.5469" width="13" height="49.6285" fill="#D5DBDE" />
      <rect x="125.5" y="48.636" width="11" height="61.5393" rx="4" fill="#D5DBDE" />
      <rect x="140.5" y="48.636" width="11" height="61.5393" rx="4" fill="#D5DBDE" />
      <rect x="90.5" y="54.5913" width="33" height="55.5839" rx="4" fill="#D5DBDE" />
      <path
        d="M106.933 122.621C125.583 122.621 140.702 107.614 140.702 89.1024C140.702 70.5907 125.583 55.584 106.933 55.584C88.2826 55.584 73.1635 70.5907 73.1635 89.1024C73.1635 107.614 88.2826 122.621 106.933 122.621Z"
        stroke="#555555"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M149.145 131L130.782 112.774"
        stroke="#555555"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
